<template>
    <div style="width: 100%">
        <template v-if="data">
            <pie-chart
                v-if="chartType === 'pie'"
                :data="data"
                :options="options"
                :width="$vuetify.display.xs ? 160 : 200"
                :height="$vuetify.display.xs ? 112 : 140"
                class="d-flex justify-center"
            />
            <doughnut-chart
                v-else-if="chartType === 'doughnut'"
                :data="data"
                :options="options"
                :width="$vuetify.display.xs ? 160 : 200"
                :height="$vuetify.display.xs ? 112 : 140"
                class="d-flex justify-center"
            />
            <line-chart
                v-else-if="chartType === 'line'"
                :data="data"
                :options="options"
                :width="$vuetify.display.xs ? 160 : 200"
                :height="$vuetify.display.xs ? 112 : 140"
                class="d-flex justify-center"
            />
            <bar-chart
                v-else
                :data="data"
                :options="options"
                :width="$vuetify.display.xs ? 160 : 200"
                :height="$vuetify.display.xs ? 112 : 140"
                class="d-flex justify-center"
            />
        </template>
    </div>
</template>
<script lang="ts">
import {
    Line as LineChart,
    Pie as PieChart,
    Doughnut as DoughnutChart,
    Bar as BarChart,
} from "vue-chartjs";
import { Prop } from "vue-facing-decorator";
import { Component, Vue, toNative } from "vue-facing-decorator";

@Component({
    components: {
        BarChart,
        PieChart,
        DoughnutChart,
        LineChart,
    },
})
export class ChartComponent extends Vue {
    @Prop({ default: null }) data: any;
    @Prop({ default: null }) options: any;
    @Prop({ default: null }) chartType: "line" | "bar" | "doughnut" | "pie";

    beforeMount() {
        console.log("data", this.data, "options", this.options, "chartType", this.chartType);
    }
}

export default toNative(ChartComponent);
</script>
<style lang="css" scoped></style>
